import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=6825fec1&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825fec1",
  null
  
)

export default component.exports